<section class="success-shell">
  <mat-card class="success-card">

    <!-- Header -->
    <div class="success-card__icon">
      <mat-icon>check_circle</mat-icon>
    </div>
    <p class="success-card__eyebrow">{{ "REGISTER.SUCCESS_EYEBROW" | translate }}</p>
    <h1>{{ "REGISTER.SUCCESS_TITLE" | translate }}</h1>
    <p class="success-card__lead">
      {{ (isTrial
            ? "REGISTER.SUCCESS_TRIAL_LEAD"
            : (isPaidPlan ? "REGISTER.SUCCESS_PAID_LEAD" : "REGISTER.SUCCESS_FREE_LEAD")) | translate }}
    </p>

    <!-- DOCU-1041: Enddatum der Testphase, sofern die API es mitgeliefert hat -->
    <p class="success-card__lead" *ngIf="isTrial && trialEndsAt">
      <strong>{{ "REGISTER.SUCCESS_TRIAL_UNTIL" | translate:{date: (trialEndsAt | date: 'longDate')} }}</strong>
    </p>

    <!-- E-Mail-Verifikation -->
    <div class="success-card__verify">
      <mat-icon class="success-card__verify-icon">mark_email_unread</mat-icon>
      <div class="success-card__verify-text">
        <h2>{{ "REGISTER.SUCCESS_VERIFY_TITLE" | translate }}</h2>
        <p>{{ "REGISTER.SUCCESS_VERIFY_HINT" | translate }}</p>
        <p class="success-card__verify-spam">{{ "REGISTER.SUCCESS_VERIFY_SPAM_HINT" | translate }}</p>
      </div>
    </div>

    <!-- Wie geht es weiter? -->
    <div class="success-card__notice">
      <div class="success-card__notice-body">
        <div class="success-card__notice-text">
          <h2>{{ "REGISTER.SUCCESS_NEXT_TITLE" | translate }}</h2>
          <p *ngIf="!isMobile">{{ "REGISTER.SUCCESS_DESKTOP_HINT" | translate }}</p>
          <p *ngIf="isMobile">{{ "REGISTER.SUCCESS_MOBILE_HINT" | translate }}</p>
          <p *ngIf="isPaidPlan && !isTrial">{{ "REGISTER.SUCCESS_PREPARED_HINT" | translate }}</p>
          <p *ngIf="isTrial">{{ "REGISTER.SUCCESS_TRIAL_HINT" | translate }}</p>
        </div>
        <img class="success-card__notice-image"
             src="/assets/branding/registration_completed.jpg"
             alt=""
             aria-hidden="true">
      </div>
    </div>

    <!-- App installieren: QR-Codes (nur Desktop) -->
    <div class="success-card__install" *ngIf="!isMobile">
      <h2>{{ "REGISTER.SUCCESS_INSTALL_TITLE" | translate }}</h2>
      <p class="success-card__install-hint">{{ "REGISTER.SUCCESS_INSTALL_HINT" | translate }}</p>
      <div class="success-card__store-grid">

        <div class="success-card__store-item">
          <img class="success-card__qr"
               src="/assets/branding/qr_code_apple.jpg"
               alt="QR-Code App Store">
          <div class="success-card__store-meta">
            <span class="store-platform">{{ "REGISTER.SUCCESS_APPLE_LABEL" | translate }}</span>
            <strong class="store-name">{{ "REGISTER.SUCCESS_APPLE_STORE" | translate }}</strong>
          </div>
          <button mat-flat-button class="store-cta" type="button" (click)="openAppleStore()">
            {{ "REGISTER.SUCCESS_APPLE_CTA" | translate }}
          </button>
        </div>

        <div class="success-card__store-item">
          <img class="success-card__qr"
               src="/assets/branding/qr_code_google.jpg"
               alt="QR-Code Google Play">
          <div class="success-card__store-meta">
            <span class="store-platform">{{ "REGISTER.SUCCESS_ANDROID_LABEL" | translate }}</span>
            <strong class="store-name">{{ "REGISTER.SUCCESS_ANDROID_STORE" | translate }}</strong>
          </div>
          <button mat-flat-button class="store-cta" type="button" (click)="openPlayStore()">
            {{ "REGISTER.SUCCESS_ANDROID_CTA" | translate }}
          </button>
        </div>

      </div>
    </div>

    <!-- Mobile: direkte Store-Links statt QR -->
    <div class="success-card__mobile-stores" *ngIf="isMobile">
      <button mat-stroked-button class="docuty-secondary" type="button" (click)="openAppleStore()">
        {{ "REGISTER.SUCCESS_APPLE_CTA" | translate }}
      </button>
      <button mat-stroked-button class="docuty-secondary" type="button" (click)="openPlayStore()">
        {{ "REGISTER.SUCCESS_ANDROID_CTA" | translate }}
      </button>
    </div>

    <!-- Weiter zum Login -->
    <div class="success-card__login">
      <div class="success-card__login-text">
        <h2>{{ "REGISTER.SUCCESS_LOGIN_TITLE" | translate }}</h2>
        <p>{{ "REGISTER.SUCCESS_LOGIN_HINT" | translate }}</p>
      </div>
      <button mat-flat-button class="docuty-cta" type="button" (click)="continueToLogin()">
        {{ "REGISTER.SUCCESS_LOGIN" | translate }}
      </button>
    </div>

    <!-- Meta -->
    <div class="success-card__meta">
      <div>
        <span>{{ "REGISTER.SUCCESS_PLAN_LABEL" | translate }}</span>
        <strong>{{ plan }}</strong>
      </div>
      <div>
        <span>{{ "REGISTER.SUCCESS_SOURCE_LABEL" | translate }}</span>
        <strong>{{ isTrial
            ? ('REGISTER.SUCCESS_SOURCE_TRIAL' | translate)
            : (source === 'stripe' ? ('REGISTER.SUCCESS_SOURCE_STRIPE' | translate) : ('REGISTER.SUCCESS_SOURCE_DIRECT' | translate)) }}</strong>
      </div>
    </div>

  </mat-card>
</section>
